import TextSearchPanes from './TextSearchPanes'

// Body for a Global Text Search grid window. Renders the builder+results | viewer
// split once the saved search is available (fetched/cached by the page), or a
// loading placeholder while a persisted window rehydrates on reload. The "no
// search loaded" case is handled by the page (empty window -> select/create prompt).
function TextSearchWindowBody({ search, panes, onPanesChange, onSaved }) {
  if (!search) {
    return <div className="display-empty">Loading search…</div>
  }
  return (
    <TextSearchPanes
      search={search}
      panes={panes}
      onPanesChange={onPanesChange}
      onSaved={onSaved}
    />
  )
}

export default TextSearchWindowBody
